<template>
  <div class="rejection-reasons-settings">

    <!-- search and filter card -->
    <v-card class="mb-4">
      <v-card-text>
        <v-row align="center" dense class="filters-row">
          <v-col cols="12" md="3">
            <v-text-field v-model="filters.search" label="بحث هنا " prepend-inner-icon="mdi-magnify" outlined dense
              hide-details clearable class="search-field" @input="onSearchInput" @click:clear="applyFilters" />
          </v-col>

          <v-col cols="12" md="9">
            <!-- here we may handle export or print buttons -->
            <v-btn depressed color="primary"
              style="min-width: 40px !importent; width: 45px; height: 48px; margin-right: 10px;"
              @click="exportsToExcel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path
                  d="M20.5076 11.3992H18.5996V5.39922C18.5996 4.73922 18.0596 4.19922 17.3996 4.19922H12.5996C11.9396 4.19922 11.3996 4.73922 11.3996 5.39922V11.3992H9.49161C8.42361 11.3992 7.88361 12.6952 8.63961 13.4512L14.1476 18.9592C14.6156 19.4272 15.3716 19.4272 15.8396 18.9592L21.3476 13.4512C22.1036 12.6952 21.5756 11.3992 20.5076 11.3992ZM6.59961 23.3992C6.59961 24.0592 7.13961 24.5992 7.79961 24.5992H22.1996C22.8596 24.5992 23.3996 24.0592 23.3996 23.3992C23.3996 22.7392 22.8596 22.1992 22.1996 22.1992H7.79961C7.13961 22.1992 6.59961 22.7392 6.59961 23.3992Z"
                  fill="white" />
              </svg>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- client register request again table -->
    <table-component :showSelect="false" itemKey="id" :headers="headers" :pagination="pagination"
      :limit="$store.state.counterOfShow" :items="clientRegisterRequestAgainList" :loading="loading" v-model="page"
      @refresh="onTableRefresh" class="client-register-request-again-table">
      <template v-slot:[`item.req_id`]="{ item }">
        <span class="value-cell" dir="ltr">{{ item.req_id }}</span>
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <span class="value-cell" dir="ltr">{{ item.name }}</span>
      </template>

      <template v-slot:[`item.mobile`]="{ item }">
        <span class="value-cell" dir="ltr">{{ item.mobile }}</span>
      </template>

      <template v-slot:[`item.history_date`]="{ item }">
        <span class="value-cell" dir="ltr">{{ item.history_date }}</span>
      </template>

      <template v-slot:[`item.count_of_try_register`]="{ item }">
        <span class="value-cell" dir="ltr">{{ item.count_of_try_register }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="primary" @click="openRequestInNewTap(item.req_id)">
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn color="primary" style="margin-right: 10px;" @click="toOrderRequest(item.req_id)">
          <v-icon small>mdi-history</v-icon>
        </v-btn>
      </template>
    </table-component>
  </div>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";

export default {
  name: "ClientRegisterRequestAgain",
  data() {
    return {
      loading: false,
      pagination: {
        limit: 10,
        count: 0,
      },
      page: 1,
      dialog: false,
      editId: null,
      searchTimer: null,
      requestController: null,
      filters: {
        search: "",
      },
      clientRegisterRequestAgainList: [],
      headers: [
        { text: "رقم الطلب", value: "req_id", sortable: true },
        { text: "اسم العميل", value: "name", sortable: true },
        { text: "رقم الهاتف", value: "mobile", sortable: true },
        { text: "تاريخ المحاولة", value: "history_date", sortable: true },
        { text: "عدد المحاولات", value: "count_of_try_register", sortable: true },
        { text: "العمليات", value: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    apiBase() {
      return `${this.$store.state.url}/employee/admin/client-register-request-again`;
    },
  },
  watch: {
    page() {
      this.listAllClientRegisterRequestAgainList();
    },
    "$store.state.counterOfShow"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.listAllClientRegisterRequestAgainList();
      }
    },
  },
  created() {
    this.listAllClientRegisterRequestAgainList();
  },
  beforeDestroy() {
    // Cancel any pending requests when component is destroyed
    if (this.requestController) {
      this.requestController.abort();
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    //===============================================================================================
    toOrderRequest(id) {
      const url = this.$router.resolve({
        name: 'request_log_new_tap',
        params: { id: id },
      }).href;
      window.open(url, '_blank');
    },
    //===============================================================================================
    openRequestInNewTap(id) {
      axiosInstance
        .get(`${this.$store.state.url}/agent/Request/Details/${id}`, {
          headers: this.request_headers(),
        })
        .then((res) => {
          const routeURL = this.$router.resolve({
            name: "request_details",
            params: { id: res.data.payload.id }
          }).href;
          window.open(routeURL, '_blank');
        });
    },
    //===============================================================================================
    async onTableRefresh() {
      this.page = 1;
      this.listAllClientRegisterRequestAgainList();
    },
    //===============================================================================================
    async listAllClientRegisterRequestAgainList() {
      console.log('Fetching client register request again list for page:', this.page, 'with search filter:', this.filters.search);
      // Cancel previous request if still pending
      // if (this.requestController) {
      //   this.requestController.abort();
      // }

      // Create new abort controller for this request
      // this.requestController = new AbortController();
      this.loading = true;

      try {
        const params = {
          page: this.page,
          per_page: this.$store.state.counterOfShow,
        };
        if (this.filters.search) params.search = this.filters.search;

        const res = await Axios.get(this.apiBase, {
          headers: this.request_headers(),
          params,
          // signal: this.requestController.signal,
          // timeout: 10000, // 10 second timeout - query is now optimized
        });

        console.log('Received response for client register request again list:', res.data);

        if (res.data?.payload) {
          this.clientRegisterRequestAgainList = res.data.payload.data || [];
          this.pagination = {
            limit: this.$store.state.counterOfShow,
            count: res.data.payload.total || 0,
          };
        }
      } catch (e) {
        console.error('Error fetching client register request again list:', e);
        // Don't show error for aborted requests
        if (e.name !== 'CanceledError' && e.code !== 'ECONNABORTED') {
          this.showPopup("error", e.response?.data?.message || "حدث خطأ أثناء التحميل");
        }
      } finally {
        console.log('Finished fetching client register request again list for page:', this.page);
        this.loading = false;
        this.requestController = null;
      }
    },
    //===============================================================================================
    applyFilters() {
      if (this.page !== 1) {
        this.page = 1;
      } else {
        this.listAllClientRegisterRequestAgainList();
      }
    },
    //===============================================================================================
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.applyFilters(), 800); // Increased to 800ms to reduce API calls
    },
    //===============================================================================================
    exportsToExcel() {
      // this.$emit("exportsToExcel");
      const table = document.querySelector(".client-register-request-again-table table");
      this.exportTableToCsv(table, this.$route.name);
    },
    //===============================================================================================

  },
};
</script>

<style scoped>
.rejection-reasons-settings {
  padding: 16px;
}

.value-cell {
  font-family: monospace;
  font-size: 0.875rem;
  letter-spacing: 0.3px;
}

.image-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-thumb {
  border-radius: 6px;
  border: 1px solid rgba(140, 140, 140, 0.3);
  background: rgba(0, 0, 0, 0.03);
}

.no-image-text {
  color: rgba(0, 0, 0, 0.38);
}

.theme--dark .product-thumb,
.dark .product-thumb {
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
}

.theme--dark .no-image-text,
.dark .no-image-text {
  color: rgba(255, 255, 255, 0.45);
}

.status-chip {
  cursor: default;
}

.status-chip__icon {
  margin-inline-end: 6px;
}

.agents-sub {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
}

.actions-cell {
  gap: 10px;
}

.action-btn {
  margin: 0;
}

.rejection-reasons-settings>>>.main__table .v-data-table td .v-btn--fab.v-size--x-small,
.rejection-reasons-settings>>>.main__table .v-data-table td .site-show-btn {
  height: 24px;
  width: 24px;
}

.rejection-reasons-settings>>>.main__table .v-data-table td .v-btn--fab.v-size--x-small .v-icon {
  font-size: 15px;
}

.theme--dark .agents-sub,
.dark .agents-sub {
  color: rgba(255, 255, 255, 0.6);
}

.role-filter__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 0;
  flex-shrink: 0;
}

.role-filter__content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.filters-row {
  margin-bottom: 0;
}

.search-field {
  margin-bottom: 0;
}

.role-filter__title {
  font-weight: 600;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.75);
}

.theme--dark .role-filter__title,
.dark .role-filter__title {
  color: rgba(255, 255, 255, 0.87);
}

.role-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.role-radio-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  padding: 8px 16px;
  border: 2px solid #3f0e40;
  border-radius: 999px;
  background-color: #fff;
  transition: all 0.2s ease;
  min-height: 38px;
}

.role-radio-label:hover {
  background-color: #f8f5f9;
  border-color: #5a2d5b;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(63, 14, 64, 0.12);
}

.role-radio-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.role-radio-text {
  font-size: 0.875rem;
  color: #3f0e40;
  font-weight: 500;
  user-select: none;
  pointer-events: none;
  white-space: nowrap;
}

.role-radio-label--active,
.role-radio-label:has(.role-radio-input:checked) {
  background-color: #3f0e40;
  border-color: #3f0e40;
  box-shadow: 0 2px 6px rgba(63, 14, 64, 0.25);
}

.role-radio-label--active .role-radio-text,
.role-radio-label:has(.role-radio-input:checked) .role-radio-text {
  color: #fff;
  font-weight: 600;
}

.theme--dark .role-radio-label,
.dark .role-radio-label {
  background-color: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.35);
}

.theme--dark .role-radio-text,
.dark .role-radio-text {
  color: rgba(255, 255, 255, 0.87);
}

.theme--dark .role-radio-label--active,
.dark .role-radio-label--active,
.theme--dark .role-radio-label:has(.role-radio-input:checked),
.dark .role-radio-label:has(.role-radio-input:checked) {
  background-color: #7b4397;
  border-color: #7b4397;
}
</style>